var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageOnBottomOfTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "16px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(107, 117, 124)",
    d: "M2.561,4.603 L13.312,4.603 L13.312,15.320 L2.561,15.320 L2.561,4.603 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    opacity: 0.478,
    fill: "rgb(50, 53, 55)",
    d: "M1.931,15.271 L2.580,15.920 L13.595,4.905 L12.946,4.256 L1.931,15.271 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    opacity: 0.478,
    fill: "rgb(50, 53, 55)",
    d: "M13.595,15.271 L12.946,15.920 L1.931,4.905 L2.580,4.256 L13.595,15.271 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(107, 117, 124)",
    d: "M0.676,0.344 L15.128,0.344 L15.128,2.160 L0.676,2.160 L0.676,0.344 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOnBottomOfTextIcon);
export default __webpack_public_path__ + "static/media/image-on-bottom-of-text-icon.f158fa127cad1cc2c26fdaa019fe32e9.svg";
export { ForwardRef as ReactComponent };